import { CONNECT_INFO, WHATSAPP_LINKS } from '../constants/connect';
import BackButton from '../components/BackButton';
import usePageMeta from '../hooks/usePageMeta';
import './Pages.css';

export default function About() {
  usePageMeta({
    title: 'Sobre a Connect - CNPJ e atendimento executivo em Osasco',
    description:
      'Conheca a Connect Veiculos: consultoria automotiva premium em Osasco com atendimento executivo, laudo cautelar e estoque selecionado.',
  });

  const valores = [
    'Procedencia e transparencia: veiculos com laudo cautelar',
    'Atendimento executivo: espaco premium, cafe e privacidade',
    'Intermediacao segura: voce ve o carro, nos cuidamos do restante',
    'Opcao abaixo da FIPE: estoque de locadora com visita ao patio',
  ];

  return (
    <div className="page-shell about-page">
      <BackButton />
      <section className="page-hero" aria-labelledby="about-title">
        <div className="page-hero__content">
          <h1 id="about-title">Sobre a Connect</h1>
          <p>
            A Connect Veiculos combina consultoria automotiva premium com curadoria de estoque proprio e
            acesso ao estoque de locadoras. Atendimento 100% agendado para entregar experiencia
            personalizada.
          </p>
          <p className="section-helper">
            Nosso papel e apresentar as duas rotas para o mesmo objetivo: carros selecionados no estoque Connect
            para ver imediatamente ou oportunidades de locadora abaixo da FIPE com todo o suporte do nosso time.
          </p>
          <div className="page-hero__actions">
            <a
              className="page-button page-button--primary"
              href={WHATSAPP_LINKS.estoque}
              target="_blank"
              rel="noreferrer"
            >
              Agendar visita
            </a>
          </div>
        </div>
      </section>

      <section className="section-card" aria-labelledby="about-info">
        <h2 id="about-info">Dados da Connect Veiculos</h2>
        <div className="info-grid">
          <div className="info-card">
            <strong>CNPJ</strong>
            <p>{CONNECT_INFO.cnpj}</p>
          </div>
          <div className="info-card">
            <strong>Endereco</strong>
            <p>{CONNECT_INFO.address}</p>
          </div>
          <div className="info-card">
            <strong>WhatsApp</strong>
            <p>{CONNECT_INFO.whatsappE164}</p>
          </div>
        </div>
      </section>

      <section className="section-card" aria-labelledby="about-values">
        <h2 id="about-values">Nossos pilares</h2>
        <ul className="valores">
          {valores.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
}